export const REDUX_STATUS = {
  INITIAL: 0,
  PENDING: 1,
  FULFILLED: 2,
  REJECTED: 3
};

export const RESPONSE_STATUS = {
  SUCCESS: "success",
  FAILURE: "failure"
};

export const FR_DISABLE_EDIT_STATUS = ["Approved", "Paid", "Closed", "Declined"];
